import { OnboardingQuestion, } from 'common/types'
import { makeAutoObservable } from 'mobx'

class CareerSummaryStore{

    buttonEnabled = false

    constructor(){
        makeAutoObservable(this)
    }

    setButtonEnabled = (newValue: boolean) => {
        this.buttonEnabled = newValue
    }

}

export const careerSummaryState = new CareerSummaryStore()